var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardSpeed = function SvgDashboardSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M16.177 5.677A8.7 8.7 0 0 0 10 3.125h-.031c-4.807.016-8.719 3.984-8.719 8.838v1.787A1.25 1.25 0 0 0 2.5 15h15a1.25 1.25 0 0 0 1.25-1.25v-1.875a8.7 8.7 0 0 0-2.573-6.198M17.5 13.75H9.352l4.278-5.883a.625.625 0 1 0-1.01-.736L7.806 13.75H2.5v-1.787q0-.36.034-.713h1.841a.625.625 0 1 0 0-1.25h-1.62c.807-3.036 3.438-5.331 6.62-5.598V6.25a.625.625 0 0 0 1.25 0V4.4a7.51 7.51 0 0 1 6.64 5.6h-1.64a.625.625 0 0 0 0 1.25h1.85q.024.31.025.625z"
  })));
};
export default SvgDashboardSpeed;